import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgSoundOffIcon = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M17 15.0002L19.5 12.5002M19.5 12.5002L22 10.0002M19.5 12.5002L17 10.0002M19.5 12.5002L22 15.0002M8.83667 6.74524C10.0339 4.94944 10.6325 4.05155 11.1114 3.81402C12.0579 3.34467 13.2061 3.69233 13.7332 4.60783C14 5.07115 14 6.15029 14 8.30856V15.6919C14 17.8501 14 18.9293 13.7332 19.3926C13.2061 20.3081 12.0579 20.6558 11.1114 20.1864C10.6325 19.9489 10.0339 19.051 8.83667 17.2552C8.60011 16.9004 8.48183 16.7229 8.33865 16.5808C8.06197 16.3062 7.71106 16.1183 7.32906 16.0405C7.13138 16.0002 6.91814 16.0002 6.49167 16.0002H5.2C4.0799 16.0002 3.51984 16.0002 3.09202 15.7822C2.71569 15.5905 2.40973 15.2845 2.21799 14.9082C2 14.4804 2 13.9203 2 12.8002V11.2002C2 10.0801 2 9.52008 2.21799 9.09226C2.40973 8.71593 2.71569 8.40997 3.09202 8.21823C3.51984 8.00024 4.07989 8.00024 5.2 8.00024H6.49167C6.91814 8.00024 7.13138 8.00024 7.32906 7.95995C7.71106 7.88209 8.06197 7.69429 8.33865 7.41963C8.48183 7.2775 8.60011 7.10008 8.83667 6.74524Z",
		stroke: "#EFEEF0",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
});
export default SvgSoundOffIcon;
